import styled from 'styled-components'
import {Box} from '@elparking/components'

export const IconBlock = styled(Box)`
    display: inline-block;
`
